define([
    'basecollection',
    'modules/currency/models/currency'
], (BaseCollection, Currency) => BaseCollection.extend({
    model: Currency,
    url: '/repos/currency'
}));
